import {  ChangeDetectorRef, Component, HostListener, Input, OnChanges, OnInit, SimpleChanges, Output, EventEmitter, inject, effect } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import {  FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { IconsComponent } from '@sml/icons';
import { ClickOutsideDirective, DiscountGroupDto, InputNumberDirective, ItemListingTypeEnum, ItemListingType, ParticipationMethodEnum, TooltipDirective, CampaignTypeEnum, BooleanEnum, IVolunteerShifts, TabItem, CampaignTypeEnumm, SettingsRequireApplicantApprovalService, ICampaignDetailModel, SlideInOutAnimation } from '@sml/utility';
import { CUSTOMFORM_PARTICIPATION_SUPPORT_URL, ITEM_PRICING_STRINGS, POST_PARTICIPATION_DETAIL_SUBHEADINGS, ticketingToggle } from './item-pricing.constants';
import { RadioButtonComponent } from '@sml/radio-button';
import { ItemParticipationDetailsComponent } from '../item-participation-details/item-participation-details.component';
import { TabsComponent } from '@sml/tabs';
import {ToggleButtonComponent} from '@sml/toggle-button'
import { ToggleRadioButtonComponent } from '@sml/toggle-radio-button';
import { DrawerComponent } from '@sml/drawer';
import { ButtonsModule } from '@sml/buttons';
import { CampaignSignalService } from '@sml/utility';

interface ParticipationOption {
  id: number;
  icon: string;
  title: string;
  subtitle: string;
}


@Component({
  selector: 'sml-item-pricing',
  imports: [CommonModule, ReactiveFormsModule, IconsComponent, InputNumberDirective, TooltipDirective, ItemParticipationDetailsComponent, TooltipDirective, TabsComponent, ToggleButtonComponent, ToggleRadioButtonComponent, DrawerComponent, ButtonsModule],
  animations: [SlideInOutAnimation],
  templateUrl: './item-pricing.component.html',
  styleUrls: ['./item-pricing.component.scss'],
})
export class ItemPricingComponent implements OnInit,OnChanges {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly requireApplicantApprovalService = inject(SettingsRequireApplicantApprovalService);
  readonly requireApplicantApproval = toSignal(this.requireApplicantApprovalService.requireApplicantApproval$, { initialValue: false });
  private readonly campaignSignalService = inject(CampaignSignalService);
  campaignDetail: ICampaignDetailModel | null = null;

  constructor(private readonly fb: FormBuilder) {
    this.initDiscountForm();
    effect(() => {
      this.campaignDetail = this.campaignSignalService.getCampaignDetail();
    });
  }
  @Input() form!: FormGroup;
  @Input() listingTypeId?: ItemListingType = ItemListingTypeEnum.Single;
  @Input() isEditItem = false;
  @Input () isDonated =false;
  @Output() volunteerShiftsChange = new EventEmitter<IVolunteerShifts[]>();
  @Output() timeZoneMandatory = new EventEmitter<boolean>();
  @Output() removeShiftError = new EventEmitter<boolean>();
  @Output() switchPriceRange = new EventEmitter<boolean>();
  @Input() showShiftError=false;
  @Input() drawerSize=false;
  @Input() disableShiftOptions : boolean | null = null;
  @Input() isNewFlag=false;
  @Input() isTicketing = false;
  @Input() set discountGroups(groups: DiscountGroupDto[]) {
    if (groups && groups.length > 0) {
      this.ticketDiscountGroups = [...groups];
      this.nextSortOrder =
        Math.max(0, ...this.ticketDiscountGroups.map((g) => g.sortOrder ?? 0)) + 1;
      if (this.isTicketing) {
        this.setTabOnEdit();
      }
    }
  }
  @Output() discountGroupsChange = new EventEmitter<DiscountGroupDto[]>();
  campaignTypeEnum=CampaignTypeEnumm
  ticketingEnum = ticketingToggle;
  showPricePerItem = false;
  ticketDiscountGroups: DiscountGroupDto[] = [];
  private nextSortOrder = 1;
  isDiscountDrawerOpen = false;
  isDiscountEdit = false;
  showDiscountGroupError = false;
  editingDiscountIndex: number | null = null;
  discountPriceType: 'set' | 'free' = 'set';
  discountPricingTab: string = ticketingToggle.setPrice;
  discountPricingSections: TabItem[] = [
    { key: ticketingToggle.setPrice, title: 'Set Price', mediaLength: 0 },
    { key: ticketingToggle.freeTicket, title: 'Free Ticket', mediaLength: 0 },
  ];
  discountGroupForm!: FormGroup;
  isMobileView=false
  booleanEnum = BooleanEnum;
  participationDetailEnum = BooleanEnum
  shiftsRadioSubheadigs = POST_PARTICIPATION_DETAIL_SUBHEADINGS
  get control() {
    return this.form.controls;
  }
  get disabledOption(){
    return this.listingTypeId === this.itemListingTypeEnum.Custom ? [BooleanEnum['Single Sign Up']] : [];
  }
  get shiftDisableOption(){
    if(this.disableShiftOptions==true){
      return [BooleanEnum['Single Sign Up']];
    }
    else if(this.disableShiftOptions==false){
      return [BooleanEnum['Multiple Shifts']]
    }
    else{
      return [];
    }
  }
  sections: TabItem[] = [
    {
      key: 'Set Price',
      title: 'Set Price',
      mediaLength: 0,
    },
    {
      key: 'Price Range',
      title: 'Price Range',
      mediaLength: 0,
    },
  ];

  currentTab = 'Set Price';

   ticketingSection: TabItem[] = [
    {
      key: ticketingToggle.setPrice,
      title: ticketingToggle.setPrice,
      mediaLength: 0,
    },
    {
      key: ticketingToggle.freeTicket,
      title: ticketingToggle.freeTicket,
      mediaLength: 0,
    },
  ];
  
   currentTicketingTab:string= ticketingToggle.freeTicket;

  public supportUrl = CUSTOMFORM_PARTICIPATION_SUPPORT_URL;
  public participationOptions: ParticipationOption[] = [
    {
      id: ParticipationMethodEnum.StripePayment,
      icon: 'dollar-o',
      title: ITEM_PRICING_STRINGS.STRIPE_TITLE,
      subtitle: ITEM_PRICING_STRINGS.STRIPE_SUB_TITLE,
    },
    {
      id: ParticipationMethodEnum.StandartInterestForm,
      icon: 'clipboard-document-list',
      title: ITEM_PRICING_STRINGS.STANDARD_FORM_TITLE,
      subtitle: ITEM_PRICING_STRINGS.STANDARD_FORM_SUB_TITLE,
    },
    {
      id: ParticipationMethodEnum.CustomForm,
      icon: 'document-pen',
      title: ITEM_PRICING_STRINGS.CUSTOM_FORM_TITLE,
      subtitle: ITEM_PRICING_STRINGS.CUSTOM_FORM_SUB_TITLE,
    },
  ];
  public showParticipationDropdown = false;
  public participationMethods = ParticipationMethodEnum;
  itemListingTypeEnum = ItemListingTypeEnum;
  _campaignType!: number;
  isVolunteerActivity = false;
  showTotalVolunteers:Boolean | null = null;
  VolunteerData : IVolunteerShifts[] = [];
  @Input() set campaignType(data: number) {
    this._campaignType = data;
    if(this._campaignType===CampaignTypeEnum['Volunteer Activity'])
      {
        this.participationOptions = this.participationOptions.filter((option) => option.id !== ParticipationMethodEnum.StripePayment);
        this.isVolunteerActivity = true;
    }
  };

  @Input() set volunteerShifts(shifts: IVolunteerShifts[]) {
    if (shifts && shifts.length > 0) {
      this.VolunteerData = shifts;
    }
  }

  get campaignType(){
    return this._campaignType;
  }

 ngOnChanges(changes: SimpleChanges): void {
  if(changes['isDonated']){
    this.isDonated=changes['isDonated'].currentValue;
   }
   if(changes['campaignType']){
     if(this.campaignType === CampaignTypeEnum['Volunteer Activity']){
       this.updateShowTotalVolunteers(this.control['hasVolunteerShifts'].value);
     }
   }
   if(changes['isTicketing']){
    this.isTicketing = changes['isTicketing'].currentValue;
    if(this.isTicketing){
      this.setTabOnEdit();
    }
   }
 }
 activeSection(activeTab: string, isTickting: boolean=false): void {
  if(!isTickting){
  this.currentTab = activeTab;
  if(this.currentTab=='Price Range'){
    this.form.get('price')?.reset();
    this.form.get('quantity')?.reset();
    this.form.get('remainingQuantity')?.reset();
    this.form.get('onlinePayment')?.setValue(true);
    this.form.get('isUnlimitedParticipation')?.setValue(false);
    this.form.get('quantity')?.enable();
    this.form.get('remainingQuantity')?.enable();
    this.switchPriceRange.emit(true)
  }
  else{
    this.form.get('customMaxPrice')?.reset();
    this.form.get('customMinPrice')?.reset();
    this.switchPriceRange.emit(false);
  }
  }
  else{
    this.currentTicketingTab=activeTab;
    this.showDiscountGroupError = false;
    if(this.currentTicketingTab===ticketingToggle.freeTicket){
      this.form.get('price')?.disable();
      this.form.get('price')?.reset();
      this.form.get('onlinePayment')?.setValue(false);
      this.form.get('isFreeTicket')?.setValue(true);
      this.ticketDiscountGroups = [];
      this.discountGroupsChange.emit(this.ticketDiscountGroups);
    }
    else if(this.currentTicketingTab===ticketingToggle.discountGroups){
      this.form.get('price')?.disable();
      this.form.get('price')?.reset();
      this.form.get('isFreeTicket')?.setValue(false);
      this.form.get('onlinePayment')?.setValue(true);
    }
    else{
      this.form.get('price')?.enable();
      this.form.get('isFreeTicket')?.setValue(false);
      this.form.get('onlinePayment')?.setValue(true);
      this.ticketDiscountGroups = [];
      this.discountGroupsChange.emit(this.ticketDiscountGroups);
    }
  }

}

ticketingPriceDisabled(){
  return this.currentTicketingTab==ticketingToggle.freeTicket;
}
getFieldName(){
  if(this.currentTab==='Price Range'){
    return 'Price';
  }
  else{
    return 'Price + Quantity'
  }
}
  ngOnInit(): void {
    this.control['onlinePayment'].valueChanges.subscribe((value: boolean) => {
      if(value && !this.isVolunteerActivity && this.currentTab==='Set Price'){
        this.showPricePerItem = true;
        if(this.isTicketing){
          this.control['price'].setValidators([Validators.required,Validators.min(2)]);
        }
        else{
          this.control['price'].setValidators([Validators.required,Validators.min(1)]);
        }
        this.control['price'].updateValueAndValidity();
      }
      else if(!value && this.currentTab==='Price Range'){
        this.activeSection('Set Price');
      }
      
      else{
        this.showPricePerItem = false;
        this.control['price'].clearValidators();
        this.control['price'].updateValueAndValidity();
      }
      
    });
    this.setTabOnEdit();

    if(this.listingTypeId === this.itemListingTypeEnum.Custom){
       this.control['onlinePayment'].setValue(true)
     }
     
       if (this.control['hasVolunteerShifts']) {
         let previousValue = this.control['hasVolunteerShifts'].value;
         
         setTimeout(() => {
           this.control['hasVolunteerShifts'].valueChanges.subscribe((currentValue) => {
             this.updateShowTotalVolunteers(currentValue);

             if (currentValue != null && previousValue != null && previousValue !== currentValue) {
               this.clearVolunteerShifts();
             }
             
             previousValue = currentValue;

             if(!currentValue){
              this.removeShiftError.emit(true);
             }
            
           });
         }, 0);
       }
     if (this.control['customMinPrice']?.value) {
    this.currentTab = 'Price Range';
    this.switchPriceRange.emit(true);
   } else {
    this.switchPriceRange.emit(false);
   }
          this.checkMobileView()
     }
     
        private clearVolunteerShifts(): void {
        this.VolunteerData = [];
        this.volunteerShiftsChange.emit([]);
        
        const remainingControl = this.form.get('remainingQuantity');
        if (remainingControl) {
          remainingControl.setValue(0);
          remainingControl.markAsDirty();
          remainingControl.updateValueAndValidity({ emitEvent: false });
        }

        const isUnlimitedParticipationControl = this.form.get('isUnlimitedParticipation');
        if (isUnlimitedParticipationControl) {
          isUnlimitedParticipationControl.setValue(false);
          isUnlimitedParticipationControl.markAsDirty();
          isUnlimitedParticipationControl.updateValueAndValidity({ emitEvent: false });
        }
        
        // Clear quantity field (Total Volunteers Needed) to 0
        const quantityControl = this.form.get('quantity');
        if (quantityControl) {
          quantityControl.setValue(0);
          quantityControl.markAsDirty();
          quantityControl.updateValueAndValidity({ emitEvent: false });
        }
        
        // Clear shifts array if it exists
        const shiftsArray = this.form.get('shifts');
        if (shiftsArray && typeof (shiftsArray as any).clear === 'function') {
          (shiftsArray as any).clear();
        }
      }
     
     private updateShowTotalVolunteers(value: boolean) {
      if(value==null){
        this.control['remainingQuantity'].clearValidators();
        this.control['quantity'].clearValidators();
        this.control['remainingQuantity'].updateValueAndValidity();
        this.control['quantity'].updateValueAndValidity();
        return
      }
      if (value) {
        this.showTotalVolunteers = false;
        this.control['remainingQuantity'].clearValidators();
        this.control['quantity'].clearValidators();
        this.control['quantity'].updateValueAndValidity();
        this.control['remainingQuantity'].updateValueAndValidity();
        this.form.get('quantity')?.enable();
        this.form.get('remainingQuantity')?.enable();
        this.timeZoneMandatory.emit(true);
      } else if (value==false && !this.isDonated) {
        this.showTotalVolunteers = true;
        if(this.isEditItem){
          this.control['remainingQuantity'].setValidators([Validators.required, Validators.min(1)]);
          this.control['remainingQuantity'].updateValueAndValidity();
        }
        else{
          this.control['quantity'].setValidators([Validators.required, Validators.min(1)]);
          this.control['quantity'].updateValueAndValidity();

        }
        this.timeZoneMandatory.emit(false);
      }
    }
    @HostListener('window:resize', ['$event'])
    onResize() {
      this.checkMobileView();
    }
    checkMobileView() {
      if (typeof window !== 'undefined') {
        this.isMobileView = window.innerWidth < 768;
      }
    }

  hideParticipationDropdown() {
    if(this.showParticipationDropdown) {
      this.control['participationMethod'].markAsTouched();
    }
    this.showParticipationDropdown = false;
  }

  setTabOnEdit(){
    if(this.isTicketing && this.form.get('isFreeTicket')?.value){
      this.activeSection(this.ticketingEnum.freeTicket,true);
    }
    else if(this.isTicketing && this.ticketDiscountGroups.length > 0){
      this.activeSection(this.ticketingEnum.discountGroups,true);
    }
    else if(this.isTicketing && !this.form.get('isFreeTicket')?.value){
      this.activeSection(this.ticketingEnum.setPrice,true);
    }
  }


  getSelectedOption(): string {
    const selectedOption = this.participationOptions.find(option => option.id === this.control['participationMethod'].value);
    return selectedOption ? selectedOption.title : 'Select';
  }

  get isAllowCustomFormSelection(): boolean {
    return !!this.control['customItemFormLink']?.value?.length;
  }

  onVolunteerShiftsChange(shifts: IVolunteerShifts[]): void {
    this.VolunteerData = shifts;
    this.volunteerShiftsChange.emit(shifts);
  }

  onPriceChange(event: Event): void {
    if (this.requireApplicantApproval() || this.campaignDetail?.requireApplicantApproval) {
      const value = (event.target as HTMLInputElement).value;
      this.form.get('onlinePayment')?.setValue(!!value);
    }
  }

  initDiscountForm(): void {
    this.discountGroupForm = this.fb.group({
      name: [null, [Validators.required]],
      price: [null, [Validators.required, Validators.min(2)]],
    });
  }

  get discountControl() {
    return this.discountGroupForm.controls;
  }

  openAddDiscountDrawer(event: Event): void {
    event.stopPropagation();
    this.isDiscountEdit = false;
    this.editingDiscountIndex = null;
    this.discountPricingTab = ticketingToggle.setPrice;
    this.discountGroupForm.reset();
    this.discountGroupForm.get('price')?.setValidators([Validators.required, Validators.min(2)]);
    this.discountGroupForm.get('price')?.updateValueAndValidity();
    this.isDiscountDrawerOpen = true;
  }

  openEditDiscountDrawer(event: Event, group: DiscountGroupDto, index: number): void {
    event.stopPropagation();
    this.isDiscountEdit = true;
    this.editingDiscountIndex = index;
    this.discountPricingTab = group.isFreeTicket ? ticketingToggle.freeTicket : ticketingToggle.setPrice;
    const patchPrice = group.isFreeTicket ? null : group.price;
    this.discountGroupForm.patchValue({ name: group.title, price: patchPrice });
    if (this.discountPricingTab === ticketingToggle.freeTicket) {
      this.discountGroupForm.get('price')?.clearValidators();
      this.discountGroupForm.get('price')?.updateValueAndValidity();
    }
    this.isDiscountDrawerOpen = true;
  }

  closeDiscountDrawer(): void {
    this.isDiscountDrawerOpen = false;
    this.discountGroupForm.reset();
    this.editingDiscountIndex = null;
    this.isDiscountEdit = false;
    this.discountPricingTab = ticketingToggle.setPrice;
  }

  saveDiscountGroupForm(): void {
    if (!this.discountGroupForm.valid) {
      this.discountGroupForm.markAllAsTouched();
      return;
    }
    const { name } = this.discountGroupForm.value;
    const isFreeTicket = this.discountPricingTab === ticketingToggle.freeTicket;
    const price = isFreeTicket ? null : this.discountGroupForm.value.price;
    if (this.isDiscountEdit && this.editingDiscountIndex !== null) {
      const existing = this.ticketDiscountGroups[this.editingDiscountIndex];
      this.ticketDiscountGroups = this.ticketDiscountGroups.map((g, i) =>
        i === this.editingDiscountIndex ? { ...existing, title: name, price, isFreeTicket } : g
      );
    } else {
      const newGroup: DiscountGroupDto = {
        title: name,
        price,
        isFreeTicket,
        sortOrder: this.nextSortOrder++,
      };
      this.ticketDiscountGroups = [...this.ticketDiscountGroups, newGroup];
    }
    this.discountGroupsChange.emit(this.ticketDiscountGroups);
    this.showDiscountGroupError = false;
    this.closeDiscountDrawer();
  }

  onDiscountTabChange(tab: string): void {
    this.discountPricingTab = tab;
    if (tab === ticketingToggle.freeTicket) {
      this.discountGroupForm.get('price')?.setValue(null);
      this.discountGroupForm.get('price')?.clearValidators();
      this.discountGroupForm.get('price')?.updateValueAndValidity();
    } else {
      this.discountGroupForm.get('price')?.setValue(null);
      this.discountGroupForm.get('price')?.setValidators([Validators.required, Validators.min(2)]);
      this.discountGroupForm.get('price')?.updateValueAndValidity();
    }
  }

  removeDiscountGroup(): void {
    if (this.editingDiscountIndex !== null) {
      this.ticketDiscountGroups = this.ticketDiscountGroups
        .filter((_, i) => i !== this.editingDiscountIndex)
        .map((group, i) => ({ ...group, sortOrder: i + 1 }));
      this.nextSortOrder = this.ticketDiscountGroups.length + 1;
      this.discountGroupsChange.emit(this.ticketDiscountGroups);
      this.closeDiscountDrawer();
    }
  }

  checkDiscountGroupValidation(): boolean {
    if (this.currentTicketingTab === ticketingToggle.discountGroups && this.ticketDiscountGroups.length === 0) {
      this.showDiscountGroupError = true;
      return true;
    }
    return false;
  }

  onUnlimitedParticipationChange(event: any): void {
    const isUnlimited = event.target.checked;
    if (isUnlimited) {
      // Set quantity to 0 to indicate unlimited
      this.form.get('quantity')?.setValue(null);
      this.form.get('remainingQuantity')?.setValue(null);
      // Disable quantity input when unlimited
      this.form.get('quantity')?.disable();
      this.form.get('remainingQuantity')?.disable();
    } else {
      // Re-enable quantity inputs
      this.form.get('quantity')?.enable();
      this.form.get('remainingQuantity')?.enable();
      // Reset to default values if needed
      if (this.form.get('quantity')?.value === 0) {
        this.form.get('quantity')?.setValue(0);
        this.form.get('remainingQuantity')?.setValue(0);
      }
    }
  }
}
